import React, { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import hasAccess, { Page } from 'helpers/hasAccess';
import withSentryErrorBoundary from 'helpers/withSentryErrorBoundary';
import { useStores } from 'core';

type PrivateRouteProps = {
  children: ReactNode;
  checkableFeature?: Page;
};

const PrivateRouteContainer = observer(({ children, checkableFeature }: PrivateRouteProps) => {
  const { authStore } = useStores();
  const location = useLocation();

  useEffect(() => {
    if (!authStore.isCheckedAuthorization) {
      authStore.checkAuth();
    }
  }, [authStore.checkAuth, authStore.isCheckedAuthorization]);

  if (authStore.isAuthorizing || !authStore.isCheckedAuthorization) {
    return null;
  }

  const access = checkableFeature ? hasAccess(checkableFeature, 'pages') : true;

  if (authStore.isAuthorized && access) {
    return <>{children}</>;
  }

  return <Navigate to={authStore.isAuthorized ? '/' : '/auth'} replace state={{ from: location }} />;
});

export const PrivateRoute = withSentryErrorBoundary(PrivateRouteContainer);
